export default __webpack_public_path__ + "static/media/edit.0a7aaaed.svg";